import { render, staticRenderFns } from "./PlantaComp.vue?vue&type=template&id=a928db90&"
import script from "./PlantaComp.vue?vue&type=script&lang=js&"
export * from "./PlantaComp.vue?vue&type=script&lang=js&"
import style0 from "./PlantaComp.vue?vue&type=style&index=0&id=a928db90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports